import { cn } from "@/nucleo/utilitarios";

interface EmptyValueProps {
  /** Texto exibido. Default: "—". Use "Não informado" para contextos formais. */
  label?: string;
  /** Variante do placeholder. */
  variant?: "dash" | "informed" | "sync";
  className?: string;
}

const VARIANT_LABELS: Record<NonNullable<EmptyValueProps["variant"]>, string> = {
  dash: "—",
  informed: "Não informado",
  sync: "Sem sincronização",
};

/**
 * Placeholder padronizado para valores ausentes/nulos em todo o sistema.
 *
 * Centraliza o que estava espalhado como "—", "Não informado" e "Sem sincronização"
 * em listagens, detalhes e tabelas. Sempre `text-muted-foreground` e tamanho herdado.
 */
export function EmptyValue({ label, variant = "dash", className }: EmptyValueProps) {
  const text = label ?? VARIANT_LABELS[variant];
  return (
    <span
      className={cn(
        "text-muted-foreground",
        variant === "dash" ? "" : "text-sm",
        className,
      )}
      aria-label={variant === "dash" ? "Sem informação" : text}
    >
      {text}
    </span>
  );
}
